import { API } from '@/api/Api'
import { GetMonitoringLiquidity, GetSocialMediaMentions, FindLatestDefenceReadiness, GetMarketPriceAction, ListBankFailures, GetBankFailuresYearOptions, GetBankFailuresCityStateOptions, GetUsBankFailures, GetBankRunBenchmarking, rerunDefenceReadiness, EditLiquidityParameters } from '@/api/query/RiskLiquidity.graphql'

export default {
  // Queries
  async GetMonitoringLiquidity (accountId, liquidityParametersId) {
    const Data = { accountId: accountId, liquidityParametersId: liquidityParametersId }
    return await API.GQLRequest(GetMonitoringLiquidity, Data)
  },

  async GetSocialMediaMentions (accountId) {
    const Data = { accountId: accountId }
    return await API.GQLRequest(GetSocialMediaMentions, Data)
  },

  async FindLatestDefenceReadiness (accountId, crisisScenario, liquidityParametersId) {
    const Data = { accountId: accountId, crisisScenario: crisisScenario, liquidityParametersId: liquidityParametersId }
    return await API.GQLRequest(FindLatestDefenceReadiness, Data)
  },

  async GetMarketPriceAction (accountId, fromDate) {
    const Data = { accountId: accountId, fromDate: fromDate }
    return await API.GQLRequest(GetMarketPriceAction, Data)
  },

  async ListBankFailures (accountId, filters = {}) {
    const Data = {
      accountId             : accountId,
      state                 : filters.selectedState,
      city                  : filters.selectedCity,
      year                  : filters.selectedYear,
      bankFailuresFieldOrder: filters.assetsSortOrder ? 'ASSETS' : 'DATE'
    }

    return await API.GQLRequest(ListBankFailures, Data)
  },

  async GetBankFailuresYearOptions (accountId) {
    const Data = { accountId: accountId }
    return await API.GQLRequest(GetBankFailuresYearOptions, Data)
  },

  async GetBankFailuresCityStateOptions (accountId) {
    const Data = { accountId: accountId }
    return await API.GQLRequest(GetBankFailuresCityStateOptions, Data)
  },

  async GetUsBankFailures (accountId, filters = {}) {
    const { fromDate, toDate } = filters
    const Data = { accountId: accountId, fromDate: fromDate, toDate: toDate }
    return await API.GQLRequest(GetUsBankFailures, Data)
  },

  async GetBankRunBenchmarking (accountId, liquidityParametersId) {
    const Data = { accountId: accountId, liquidityParametersId: liquidityParametersId }
    return await API.GQLRequest(GetBankRunBenchmarking, Data)
  },

  // Mutations
  async RerunDefenceReadiness (accountId, assumptions = {}, crisisScenario, liquidityParametersId) {
    const Data = { accountId: accountId, assumptions: assumptions, liquidityParametersId: liquidityParametersId }
    return await API.GQLRequest(rerunDefenceReadiness, Data)
  },
  async EditLiquidityParameters (accountId, liquidityAssumptions = {}) {
    const Data = { accountId: accountId, liquidityAssumptions: liquidityAssumptions }
    return await API.GQLRequest(EditLiquidityParameters, Data)
  }
}
